<template>
  <div>
    <el-input
      v-model="orderId"
      placeholder="请输入订单号"
      style="width:240px"
      @keyup.enter.native="search(orderId)"
    ></el-input>
    <el-button
      type="primary"
      @click="search(orderId)"
    >搜索</el-button>
    <el-form label-width="120px">
      <el-form-item label="下载模板">
        <a href="https://linggan-1316937351.cos.ap-shanghai.myqcloud.com/jdorder-template.xlsx">订单批量查询模板.xlsx</a>
      </el-form-item>
      <el-form-item label="选择Excel">
        <el-upload
          ref="dragupload"
          :auto-upload="false"
          :on-success="fileUploadSuccess"
          :on-error="fileUploadError"
          :disabled="importBtnDisabled"
          :limit="1"
          :headers="mytoken"
          :action="'/api/jd/orderId/mx/cwBatchGet'"
          :data="uploadData"
          :on-remove="handleRemove"
          name="file"
        >
          <el-button
            slot="trigger"
            size="small"
            type="primary"
          >选取文件</el-button>
          <el-button
            :loading="loading"
            style="margin-left: 10px;"
            size="small"
            type="success"
            @click="submitUpload"
          >麦炫订单批量查询</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="选择导出Excel">
        <el-upload
          ref="exportupload"
          :auto-upload="false"
          :on-success="fileExportSuccess"
          :on-error="fileExportError"
          :disabled="importBtnDisabled"
          :limit="1"
          :headers="mytoken"
          :action="'/api/jd/orderId/mx/cwBatchExport'"
          :data="uploadData"
          :on-remove="handleRemove"
          name="file"
        >
          <el-button
            slot="trigger"
            size="small"
            type="primary"
          >选取文件</el-button>
          <el-button
            :loading="loading"
            style="margin-left: 10px;"
            size="small"
            type="success"
            @click="submitExport"
          >麦炫订单批量导出</el-button>
        </el-upload>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      border
      ref="filterTable"
      style="width: 100%"
      v-loading="loading"
      height="80%"
    >
      <template slot="empty">
        <p class="emptyText">{{ tableEmptyText }}</p>
      </template>

      <el-table-column
        prop="orderId"
        label="订单编号"
      >
      </el-table-column>

      <el-table-column
        prop="parentId"
        label="主单号"
      >
      </el-table-column>

      <el-table-column
        prop="trace"
        label="是否同店"
      >
      </el-table-column>

      <el-table-column
        prop="activityReturn"
        label="是否会场"
      >
      </el-table-column>

      <el-table-column
        prop="activityName"
        label="是否奖励活动"
      >
      </el-table-column>

      <el-table-column
        prop="orderTime"
        label="下单日期"
      >
      </el-table-column>

      <el-table-column
        prop="finishTime"
        label="完成日期"
      >
      </el-table-column>

      <el-table-column
        prop="bonusText"
        label="订单状态"
      >
      </el-table-column>

      <el-table-column
        prop="shopname"
        label="店铺名称"
      >

      </el-table-column>

      <el-table-column
        prop="skuName"
        label="商品名称"
      >

      </el-table-column>

      <el-table-column
        prop="actualCosPrice"
        label="实际计佣金额"
      >

      </el-table-column>

      <el-table-column
        prop="commissionRate"
        label="佣金比例"
      >

      </el-table-column>

      <el-table-column
        prop="platform"
        label="下单主体"
      >
      </el-table-column>

    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { getJdOrder, getJdOrderLog, getShowLogUserIds } from "@/api/jdorder";
import store from "@/store";
export default {
  data() {
    return {
      orderId: "",
      tableData: [],
      tableData2: [],
      tableEmptyText: "暂无数据",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      showLog: false,
      importBtnDisabled: false
    };
  },

  computed: {
    mytoken() {
      return {
        "x-auth-token": localStorage.getItem("token")
      };
    }
  },

  methods: {
    async search(val) {
      if (!val) {
        this.$message({
          message: "订单号不能为空",
          type: "warning"
        });
        return;
      }
      this.loading = true;
      await getJdOrder({ orderId: val }).then(res => {
        this.loading = false;
        if (res.code == 1000) {
          this.tableData = res.data;
          this.tableData2 = res.data;
          this.total = res.data.total;
        } else if (res.code == 10000) {
          this.tableData = [];
          this.tableEmptyText = res.msg;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },

    //点击按钮上传文件到接口里面
    submitUpload() {
      this.importBtnDisabled = true;
      this.loading = true;
      this.$refs.dragupload.submit();
    },

    //点击按钮上传文件到接口里面
    submitExport() {
      this.importBtnDisabled = true;
      this.loading = true;
      this.$refs.exportupload.submit();
    },
    //上传成功
    fileUploadSuccess(res) {
      //提示信息
      this.loading = false;
      this.importBtnDisabled = false;
      this.$message({
        type: "success",
        message: "上传成功"
      });
      if (res.code === 1000) {
        this.tableData = res.data;
        this.tableData2 = res.data;
        this.total = res.data.total;
      } else if (res.code == 10000) {
        this.tableData = [];
        this.tableEmptyText = res.msg;
      } else {
        this.$message({
          message: res.msg,
          type: "warning"
        });
      }
    },
    //上传失败
    fileUploadError() {
      this.loading = false;
      this.importBtnDisabled = false;
      this.$message({
        type: "error",
        message: "失败"
      });
    },
    //上传成功
    fileExportSuccess(response) {
      console.log(response);
      //提示信息
      this.loading = false;
      this.importBtnDisabled = false;
      this.$message({
        type: "success",
        message: "上传成功"
      });
      if (response.code === 1000) {
        const link = document.createElement("a");
        link.href = response.data;
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        this.$message({
          message: response.msg,
          type: "warning"
        });
      }
    },
    //上传失败
    fileExportError() {
      this.loading = false;
      this.importBtnDisabled = false;
      this.$message({
        type: "error",
        message: "失败"
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search(); // 重新搜索以更新分页数据
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search(); // 重新搜索以更新分页数据
    }
  }
};
</script>

